import React from 'react';

export type LeverToggleProps = {
  value: boolean;
  showLabels: boolean;
  isDisabled: boolean;
  testId?: string;
  onValueChanged: (newValue: boolean) => void;
};

export const LeverToggle = ({
  value,
  showLabels,
  onValueChanged,
  isDisabled,
  testId
}: LeverToggleProps) => (
  <div className="switch lever-toggle">
    <span className={!showLabels ? 'invisible' : value ? 'transparent' : ''}>
      Off
    </span>
    <label data-testid={testId}>
      <input
        type="checkbox"
        className="clickable"
        checked={value}
        disabled={isDisabled}
        onChange={(event) => onValueChanged(event.target.checked)}
      />
      <span className="lever" />
    </label>
    <span className={!showLabels ? 'invisible' : !value ? 'transparent' : ''}>
      On
    </span>
  </div>
);
